import React from 'react';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames } from '@philips-internal/oswald-ui-utils';
import { LegendItem } from '../legend-item/legend-item.js';
import { useLegends } from '../legends-context.js';
function LegendsItems(props) {
    const context = useLegends();
    const className = classNames({
        'c-legends__items': true,
        'u-scrollbar': true,
        [`${props.className}`]: Boolean(props.className),
    });
    return (React.createElement("ul", { "aria-label": MessageService.translate('tws.legends.legends-description-label'), className: className }, context.getItems().map((item) => {
        return (React.createElement("li", { key: item.value },
            React.createElement(LegendItem, { ...item, notifyLegends: false, size: context.size })));
    })));
}
export { LegendsItems, };
//# sourceMappingURL=legends-items.js.map